import React from 'react'
import PropTypes from 'prop-types'
import DenaliScopePicker from '../DenaliAnalysis/DenaliScopePicker'
import DenaliScopeTypePicker from '../DenaliAnalysis/DenaliScopePicker/ScopeTypePicker'
import { useDenaliScopes } from '../DenaliAnalysis/filters/DenaliScopeProvider'

/**
 * Blueprint presentation renderer for the "Scope Selector" type.
 *
 * In simple mode, renders a DenaliScopePicker (single scope type dropdown).
 * In complex mode, renders a DenaliScopeTypePicker alongside the value picker
 * so the user can switch between scope types (e.g. Advisor vs Client).
 *
 * Must be rendered inside a DenaliScopeProvider (typically via QBPScopeProvider).
 */
function BlueprintScopeSelector ({ config }) {
  const { scopes } = useDenaliScopes()
  const { display, size, hideAvatars, multiSelect } = config ?? {}

  if (display === 'complex' && scopes.length >= 2) {
    return (
      <div className='d-flex align-items-center gap-sm'>
        <DenaliScopeTypePicker />
        <DenaliScopePicker
          size={size}
          hideAvatars={hideAvatars}
          multiSelect={multiSelect}
        />
      </div>
    )
  }

  return (
    <DenaliScopePicker
      size={size}
      hideAvatars={hideAvatars}
      multiSelect={multiSelect}
    />
  )
}

BlueprintScopeSelector.propTypes = {
  config: PropTypes.shape({
    mode: PropTypes.oneOf(['membership', 'purpose']),
    display: PropTypes.oneOf(['simple', 'complex']),
    multiSelect: PropTypes.bool,
    hideAvatars: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'lg'])
  })
}

export default BlueprintScopeSelector
